'use strict';

import { Dropdown } from './dropdown.js';

export class DropdownMyadsactions extends Dropdown {
	constructor(component_key) {
		super(component_key);
		this.$body = jQuery('body');
		this.init_sharing()
	}
	add_events() {
		this.$root.on('click', `.js-${this.id}_option`, this.option_click_handler.bind(this));
		this.$body.on('blur', `.js-${this.id}`, this.close_all.bind(this));
	}
	
	option_click_handler(event) {
		const $element = jQuery(event.currentTarget);
		this.$root = $element.closest(`.js-${this.id}`);
		this.$list = this.$root.find(`.js-${this.id}_list`);
		this.$selected = this.$root.find(`.js-${this.id}_selected`);
		this.$options = this.$root.find(`.js-${this.id}_option`);
		this.$posting = this.$root.closest('.js-myads_posting');
		const $all_other_lists = jQuery(`.js-${this.id}_list`).not(this.$options);
		const $all_other_options = jQuery(`.js-${this.id}_option`).not(this.$options);
		if ($all_other_lists.length) {
			yalwa.basics.bem_modifier($all_other_lists, 'active', 'remove');
		}
		if ($all_other_options.length) {
			yalwa.basics.bem_modifier($all_other_options, 'active', 'remove');
		}
		yalwa.basics.bem_modifier(this.$list, 'active', 'toggle');
		yalwa.basics.bem_modifier(this.$options, 'active', 'toggle');
	}

	init_sharing() {
		const $share_option = jQuery('.js-myads_share');
		if (
			navigator.share !== undefined ||
			yalwa.v.is_phonegap
		) {
			this.$body.on('click', '.js-myads_share', this.share.bind(this));
		} else {
			$share_option.remove();
		}
	}
	share() {
		const url = this.$posting.find('.js-myads_link').prop('href');
		const title = this.$posting.find('.js-myads_header').text();
		if (yalwa.v.is_phonegap) {
			yalwa.mobile.cordova.cordova_send({
				action: 'share',
				params: {
					provider: 'None',
					url: url,
					is_profile: false
				}
			});
		} else {
			navigator.share({
				title: title,
				url: decodeURIComponent(url)
			});
		}
	}
}
